export const environment = {
  production: true,
  type: 'web',
  envName: '110330-oberdorf',
  mandant_id: '110330-oberdorf',
  url: 'https://proxy.mms-rcs.de',
  mainModule: './config/web/app.module'
}
